@if(isVisible && toast){
    <div class="toast-container"
          [class.toast-container--success-banner]="toast.variant === 'success-banner'">
        <div class="toast-pill"
            [style.--toast-duration]="animationD + 'ms'"
            [class.toast-success]="toast.type === 'success'"
            [class.toast-error]="toast.type === 'error'"
            [class.toast-warning]="toast.type==='warning'"
            [class.toast-info]="toast.type==='info'"
            [class.toast-success-banner]="toast.variant === 'success-banner'">

            <div class="toast-icon">
                <img [src]="iconMap[toast.type]" alt="toast icon">
            </div>
        
            <div class="toast-content">
                <div class="toast-head">
                    <span class="toast-message">{{toast.message}}</span>  
                </div>
                
                <p class="toast-duration">
                    Stängs automatiskt om 5 sekunder
                </p>               
            </div>  
            
            <div class="toast-action">
                <span class="toast-status"
                    [class.status-success]="toast.type === 'success'"
                    [class.status-error]="toast.type === 'error'"
                    [class.status-warning]="toast.type === 'warning'"
                    [class.status-info]="toast.type ==='info'">
                    {{statusLabels[toast.type]}}
                </span>    
            </div>

            <div class="toast-progress"></div>

        </div>
    </div>
   
    

}
